var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container-fluid right_wrapper"},[_c('AddAsinScraperHeader'),_c('AddAsinScraperDetails',{staticClass:"table_wrap no_footer pt-2"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }